import { useCallback, useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { readTocPinned, writeTocPinned } from '../utils/toc-pinned-storage';

export function usePersistedTocPinned(
  documentId: string | null | undefined,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [isTocPinned, setIsTocPinnedState] = useState<boolean>(() => readTocPinned(documentId));

  useEffect(() => {
    setIsTocPinnedState(readTocPinned(documentId));
  }, [documentId]);

  const setIsTocPinned = useCallback<Dispatch<SetStateAction<boolean>>>(
    (value) => {
      setIsTocPinnedState((previous) => {
        const next = typeof value === 'function' ? value(previous) : value;
        writeTocPinned(documentId, next);
        return next;
      });
    },
    [documentId],
  );

  return [isTocPinned, setIsTocPinned];
}
